import styled from 'styled-components';

const Row = styled.div`
    width: 100%;
    min-height: 50px;
    display: flex;
`;

export default Row;



// WEBPACK FOOTER //
// ./src/components/list/Filters/layout/Row.js